<template>
    <g-map-autocomplete v-if="map && !mobile" :class="styleClass" @place_changed="placeChanged" :placeholder="placeholder"/>
</template>

<script>
  export default {
    name: 'searchMenu',
    props: ['map', 'placeholder'],
    components: {},

    data() {
      return {
          placeMarker: null,
          mobile: false
      }
    },

    computed: {
      styleClass(){
        return {
          'placesSearch': !this.mobile,  
          'placesSearchMobile': this.mobile}
        }
    },

    methods: {
      placeChanged(place) {
        if(this.placeMarker){
          this.placeMarker.setMap(null)
        }
        this.placeMarker = null
        this.placeMarker = new google.maps.Marker({
          position: place.geometry.location
        })
        this.placeMarker.setMap(this.map)
        var bounds = new google.maps.LatLngBounds();
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
        this.map.fitBounds(bounds);
      },
    },

    mounted(){
        if(this.$q.screen.name == 'xs'){
            this.mobile = true
        }
    }
  }

</script>

<style lang="sass">
  .placesSearch
    position: absolute
    border: none
    top: 10px
    left: 200px
    z-index: 2
    width: 200px
    height: 40px
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2)
    padding-left: 10px

  .placesSearchMobile
    position: absolute
    border: none
    top: 60px
    left: 10px
    z-index: 0
    width: 166px
    height: 40px
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2)
    padding-left: 10px
  
</style>
